import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { MatchDetailLive } from '../../models/match-data.models';
import { GenericService } from '../../../../services/generic.services';
import { LocalStorageService } from '../../../../services/localstorage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SportsService } from '../../../../services/sport.service';
import { UtilitiesService } from '../../../../services/utilities.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dashboard-sports',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard-sports.component.html',
  styleUrl: './dashboard-sports.component.scss',
})
export class DashboardSportsComponent {
  urlImg = environment.urlIMG;
  urlIcon = environment.urlIcon;

  interval: any;
  infoMatch: MatchDetailLive = {} as MatchDetailLive;

  today: any = '';
  idCompetition = '';

  @Input() set info(data: MatchDetailLive) {
    this.infoMatch = data;
  }

  public isFixed: boolean = false;

  constructor(
    private lsService: LocalStorageService,
    private ref: ChangeDetectorRef,
    public _activateRoute: ActivatedRoute,
    public menuService: SportsService,
    private utilityServices: UtilitiesService,
    private genericServices: GenericService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.today = this.genericServices.getCurrentDate();
    this.idCompetition =
      this._activateRoute.snapshot.paramMap.get('idCompetition') || '';
  }

  markTeamFavorite(team: any, type: string, info: any) {
    if (
      this.lsService.setFavoritesTeam({
        idTeam: team.id,
        national: team.national,
        logoCountry: team.country_logo,
        logo: team.logo,
        nameEs: team.name,
        nameEn: team.name,
        countryEs: '',
        countryEn: '',
        country: team.country,
      })
    ) {
      type === 'H'
        ? (info.favoriteHome = !info.favoriteHome)
        : (info.favoriteAway = !info.favoriteAway);
      this.ref.markForCheck();
    }
  }

  openTeam(team: any) {
    if (this.menuService.getSelectedSport() !== 'Tenis')
      this.router.navigate([
        '/' +
          this.menuService.getSelectedSport() +
          '/' +
          this.utilityServices.getCountry(team.country) +
          '/team/' +
          team.name +
          '/' +
          team.id,
      ]);
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }
}
